"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const extensible_custom_error_1 = __importDefault(require("extensible-custom-error"));
class ChibaLangError extends extensible_custom_error_1.default {
    constructor(message, ...args) {
        super(message, ...args);
    }
}
exports.ChibaLangError = ChibaLangError;
class NullReferenceVariableError extends ChibaLangError {
    constructor(message, ...args) {
        super(`変数が参照できませんでした。${message}`, ...args);
    }
}
exports.NullReferenceVariableError = NullReferenceVariableError;
class NullReferenceFunctionError extends ChibaLangError {
    constructor(message, ...args) {
        super(`関数が参照できませんでした。${message}`, ...args);
    }
}
exports.NullReferenceFunctionError = NullReferenceFunctionError;
class TypeError extends ChibaLangError {
    constructor(message, ...args) {
        super(`処理するデータ型が異なります。${message}`, ...args);
    }
}
exports.TypeError = TypeError;
class OutOfRangeError extends ChibaLangError {
    constructor(message, ...args) {
        super(`配列の範囲を超えています。${message}`, ...args);
    }
}
exports.OutOfRangeError = OutOfRangeError;
